import * as React from "react";
import { Grid } from "@mui/material";

import { H1, H3, H6, P } from "#common/headings";
import { PageContainer } from "#pages/PageContainer";
import HowToChooseAGoodResult from "assets/video/how-to-choose-a-good-result.mp4";
import AnatomyOfASearchResult from "assets/video/anatomy-of-a-search-result.mp4";
import HowToDealWithInformationRichColumns from "assets/video/how-to-deal-with-information-rich-columns.mp4";
import HowToFindAColumnByName from "assets/video/how-to-find-column-by-name.mp4";
import HowToRememberAColumn from "assets/video/how-to-remember-a-column.mp4";

export const HelpPage = () => {
    return (
        <PageContainer>
            <H1 sx={{ marginBottom: "5px" }}>Help</H1>
            <P>
                This page provides several short tutorial videos, describing how
                to use advanced features of the Open Data Dialog.
            </P>
            <Grid container spacing={3} sx={{ marginTop: "10px" }}>
                <Grid item xs={12}>
                    <H6>How To Choose a Good Result</H6>
                    <video src={HowToChooseAGoodResult} width="100%" controls />
                </Grid>
                <Grid item xs={6}>
                    <H6>Anatomy of a Search Result</H6>
                    <video src={AnatomyOfASearchResult} width="100%" controls />
                </Grid>
                <Grid item xs={12}>
                    <H3>Data Library</H3>
                </Grid>
                <Grid item xs={6}>
                    <H6>How to Find a Column by Name</H6>
                    <video src={HowToFindAColumnByName} width="100%" controls />
                </Grid>
                <Grid item xs={6}>
                    <H6>How to Remember a Column</H6>
                    <video src={HowToRememberAColumn} width="100%" controls />
                </Grid>
                <Grid item xs={6}>
                    <H6>How to Deal with Information-Rich Columns</H6>
                    <video
                        src={HowToDealWithInformationRichColumns}
                        width="100%"
                        controls
                    />
                </Grid>
            </Grid>
        </PageContainer>
    );
};
